document.addEventListener('DOMContentLoaded' , (e) => {
    let btnPlay = document.querySelector('.btn-play_video');
    let videoPlayer = document.querySelector('#video-cocktail');

    videoPlayer?.addEventListener('click' , (e) => {
        e.preventDefault();
        btnPlay.click();
    })

    btnPlay.addEventListener('click' , (e) => {
        if (videoPlayer.paused == true) {
            btnPlay.classList.add('paused');
            videoPlayer.play();
        }else{
            btnPlay.classList.remove('paused');
            videoPlayer.pause();
        }
    })

    //Best Beer's
    const wrapperBear = document.querySelector('.best-beer');
    const wrapperOptions = wrapperBear.querySelector('.beer-selector-wrapper');
    const btnTrigger = wrapperBear.querySelector('.beer--item-name');
    const itemsOptions = wrapperBear.querySelectorAll('.beer-selected-option');
    const beerWrapper = wrapperBear.querySelectorAll('.wrapper--best-beer__inner .best-beer__inner');
    const arrow = wrapperBear.querySelector('.arrow-select');
    

    [wrapperOptions, btnTrigger].forEach(btn => {
        btn.addEventListener('click' , (e) => {
            e.preventDefault();
            console.log(e.target)
            if(e.target.classList[0] == 'beer--item-name'){
                if(!wrapperOptions.classList.contains('open')){
                    wrapperOptions.classList.add('open')
                    arrow?.classList.add('arrow-open');
                }else{
                    wrapperOptions.classList.remove('open');
                    arrow?.classList.remove('arrow-open')
                }
            }

            if(e.target.classList[0] == 'beer-selector-wrapper'){
                wrapperOptions.classList.remove('open')
            }
        })
    });

    arrow?.addEventListener('click', () => {
        btnTrigger.click();
    })

    itemsOptions.forEach(ele => {
        ele.addEventListener('click' , (e) => {
            const textItem = ele.innerText;
            const dataItem = ele.dataset.beerItem;
            btnTrigger.innerText = textItem;
            btnTrigger.dataset.beerItem = dataItem;
            wrapperOptions.classList.remove('open')
            arrow?.classList.remove('arrow-open');

            beerWrapper.forEach(beer => {
                const beerItem = beer.dataset.item;
                if(beerItem == dataItem){
                    beer.classList.add('active');
                }else{
                    beer.classList.remove('active');
                }
            })
        })
    });
})